import React from 'react';

import './index.less';

import IbModal, { IbModalPosition } from '../common/IbModal';
import MarkdownContent from '../MarkdownContent';
import { getTranslateFunc } from '../../utils/stringUtil';
import IbButton from '../common/IbButton';
import { AgentMessageToolSchema } from '../../../gamma-api';

const MAIN_CLASS_NAME = 'agent-message-tool-modal';

export interface IAgentMessageToolModalProps {
  toolSchema?: AgentMessageToolSchema;
  visible: boolean;
  onCancel: () => void;
}

const AgentMessageToolModal: React.FC<IAgentMessageToolModalProps> = ({ toolSchema, visible, onCancel }) => {
  const translate = getTranslateFunc('Agent: Testing chat: Tool modal:');

  const renderFooter = () => {
    return (
      <IbButton type="secondary" onClick={onCancel}>
        {translate('Cancel')}
      </IbButton>
    );
  };

  return (
    <IbModal
      className={MAIN_CLASS_NAME}
      footer={renderFooter()}
      position={IbModalPosition.Centered}
      title={toolSchema?.name}
      visible={visible}
      onCancel={onCancel}
    >
      <MarkdownContent>{`\`\`\`json\n${JSON.stringify(toolSchema, null, 2)}\n\`\`\``}</MarkdownContent>
    </IbModal>
  );
};

export default AgentMessageToolModal;
